export class ContactPhone {

    category: string;
    name: string;
    type: string;
    value: string;
    isd: string;

    constructor(category: string,
        name: string,
        type: string,
        value: string,
        isd: string) {
        this.category = category;
        this. name = name;
        this. type = type;
        this.value = value;
        this.isd = isd;
    }
}
